class PdpSwatchModalWrapper extends HTMLElement {
  constructor() {
    super();

    this.handleOpen = (e) => {
      const el = this.querySelector("template").content.children[0];

      const html = el.outerHTML;
      e.target.dispatchEvent(
        new CustomEvent("markup-modal:open", {
          bubbles: true,
          detail: { html, target: "swatch-modal" },
        }),
      );
    };
  }

  connectedCallback() {
    document.addEventListener("swatch-modal:open", this.handleOpen);
  }

  disconnectedCallback() {
    document.removeEventListener("swatch-modal:open", this.handleOpen);
  }
}

if (!customElements.get("pdp-swatch-modal-wrapper")) {
  customElements.define("pdp-swatch-modal-wrapper", PdpSwatchModalWrapper);
}
